import { PageType } from "shared/lib/page-type";

export const pathname = "/games/mini-sudoku/[date]";

export type RouteParameters = {
  date: string;
};

export const page = {
  pathname,
  route(query: { date: string }) {
    const { date } = query;

    return {
      pathname: `/games/mini-sudoku/${date}`,
      query: {
        date,
        pageType: PageType.GamesMiniSudoku,
      },
    };
  },
};
